import styled from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

const PUBLISHER_COLUMN_WIDTH = "160px";

export const HeatMapLoaderWrapper = styled(Flex)`
    min-height: 260px;

    & > *,
    & svg {
        width: 100%;
    }
`;

export const PublisherLabelWrapper = styled.span`
    display: inline-flex;
    gap: 4px;
    width: 100%;
    min-width: 0;
    justify-content: flex-end;
`;

export const PublisherLabelText = styled.span`
    display: inline-flex;
    width: 100%;
    min-width: 0;
    justify-content: flex-end;
`;

export const VerificationHeatMapWrapper = styled.div`
    .heat-map__y-axis-label,
    .heat-map__y-axis-header {
        width: ${PUBLISHER_COLUMN_WIDTH};
        min-width: ${PUBLISHER_COLUMN_WIDTH};
        max-width: ${PUBLISHER_COLUMN_WIDTH};
        justify-content: flex-end;
    }
`;
